var _rect, _linearGradient, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _g195, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _g205, _g206, _g207, _g208, _g209, _g210, _g211, _g212, _g213, _g214, _g215, _g216, _g217, _g218, _g219, _g220, _g221, _g222, _g223, _g224, _g225, _g226, _g227, _g228, _g229, _g230, _g231, _g232, _g233, _g234, _g235, _g236, _g237, _g238, _g239, _g240, _g241, _g242, _g243, _g244, _g245, _g246, _g247, _g248, _g249, _g250, _g251, _g252, _g253, _g254, _g255, _g256, _g257, _g258, _g259, _g260, _g261, _g262, _g263, _g264, _g265, _g266, _g267, _g268, _g269, _g270, _g271, _g272, _g273, _g274, _g275, _g276, _g277, _g278, _g279, _g280, _g281, _g282, _g283, _g284, _g285, _g286, _g287, _g288, _g289, _g290, _g291, _g292, _g293, _g294, _g295, _g296, _g297, _g298, _g299, _g300, _g301, _g302, _g303, _g304, _g305, _g306, _g307, _g308, _g309, _path, _path2, _path3, _g310, _g311, _g312, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeltegramQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "2277px",
    height: "2277px",
    viewBox: "0 0 2277 2277",
    enableBackground: "new 0 0 2277 2277",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2277,
    height: 2277,
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138,138)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "rotate(90)",
    id: "grad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "rgb(84,115,241)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "rgb(63,41,223)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "gmask"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(690,0) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(759,0) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(966,0) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,0) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1242,0) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1311,0) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(690,69) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(759,69) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1104,69) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,69) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828,138) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(966,138) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035,138) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,138) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1311,138) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,138) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(621,207) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(690,207) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(897,207) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1104,207) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1242,207) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828,276) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1242,276) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,345) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(690,345) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(759,345) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828,345) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035,345) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1104,345) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1311,345) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,345) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,414) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(690,414) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828,414) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(966,414) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1104,414) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1242,414) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,414) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(759,483) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(897,483) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035,483) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1104,483) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,483) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1242,483) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,483) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,552) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207,552) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345,552) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(414,552) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,552) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(759,552) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(966,552) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1104,552) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1449,552) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1587,552) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g55 || (_g55 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,621) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138,621) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g57 || (_g57 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207,621) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g58 || (_g58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345,621) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g59 || (_g59 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,621) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(690,621) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g61 || (_g61 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828,621) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(897,621) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g63 || (_g63 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035,621) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1104,621) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g65 || (_g65 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,621) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g66 || (_g66 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1449,621) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g67 || (_g67 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1518,621) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1587,621) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g69 || (_g69 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1725,621) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g70 || (_g70 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1932,621) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g72 || (_g72 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g73 || (_g73 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g74 || (_g74 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g75 || (_g75 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g76 || (_g76 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(414,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g77 || (_g77 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g78 || (_g78 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g79 || (_g79 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(759,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g80 || (_g80 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(897,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g81 || (_g81 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(966,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g82 || (_g82 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g83 || (_g83 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g84 || (_g84 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1311,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g85 || (_g85 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1449,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g86 || (_g86 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1518,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g87 || (_g87 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1587,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g88 || (_g88 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1656,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g89 || (_g89 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1725,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g90 || (_g90 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1794,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g91 || (_g91 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1863,690) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g92 || (_g92 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207,759) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g93 || (_g93 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,759) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g94 || (_g94 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,759) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g95 || (_g95 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828,759) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g96 || (_g96 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(897,759) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g97 || (_g97 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1104,759) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g98 || (_g98 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1518,759) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g99 || (_g99 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1587,759) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g100 || (_g100 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1794,759) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g101 || (_g101 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1863,759) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g102 || (_g102 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,828) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g103 || (_g103 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69,828) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g104 || (_g104 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138,828) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g105 || (_g105 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(276,828) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g106 || (_g106 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(414,828) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g107 || (_g107 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828,828) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g108 || (_g108 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(966,828) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g109 || (_g109 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035,828) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g110 || (_g110 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,828) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g111 || (_g111 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1311,828) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g112 || (_g112 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,828) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g113 || (_g113 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1449,828) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g114 || (_g114 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1518,828) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g115 || (_g115 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1725,828) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g116 || (_g116 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1863,828) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g117 || (_g117 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1932,828) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g118 || (_g118 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207,897) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g119 || (_g119 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,897) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g120 || (_g120 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(690,897) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g121 || (_g121 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828,897) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g122 || (_g122 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(897,897) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g123 || (_g123 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(966,897) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g124 || (_g124 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035,897) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g125 || (_g125 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1104,897) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g126 || (_g126 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,897) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g127 || (_g127 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1311,897) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g128 || (_g128 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,897) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g129 || (_g129 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1449,897) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g130 || (_g130 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g131 || (_g131 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g132 || (_g132 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g133 || (_g133 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(414,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g134 || (_g134 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g135 || (_g135 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(690,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g136 || (_g136 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g137 || (_g137 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(897,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g138 || (_g138 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(966,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g139 || (_g139 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g140 || (_g140 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1242,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g141 || (_g141 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1449,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g142 || (_g142 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1656,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g143 || (_g143 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1725,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g144 || (_g144 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1794,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g145 || (_g145 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1863,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g146 || (_g146 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1932,966) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g147 || (_g147 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,1035) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g148 || (_g148 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138,1035) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g149 || (_g149 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(621,1035) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g150 || (_g150 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(759,1035) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g151 || (_g151 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828,1035) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g152 || (_g152 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035,1035) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g153 || (_g153 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,1035) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g154 || (_g154 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1242,1035) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g155 || (_g155 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,1035) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g156 || (_g156 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1449,1035) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g157 || (_g157 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1656,1035) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g158 || (_g158 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1725,1035) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g159 || (_g159 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1863,1035) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g160 || (_g160 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,1104) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g161 || (_g161 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69,1104) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g162 || (_g162 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(276,1104) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g163 || (_g163 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345,1104) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g164 || (_g164 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(414,1104) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g165 || (_g165 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,1104) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g166 || (_g166 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,1104) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g167 || (_g167 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(621,1104) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g168 || (_g168 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(690,1104) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g169 || (_g169 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(759,1104) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g170 || (_g170 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(897,1104) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g171 || (_g171 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,1104) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g172 || (_g172 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1311,1104) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g173 || (_g173 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1449,1104) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g174 || (_g174 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1863,1104) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g175 || (_g175 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138,1173) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g176 || (_g176 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(276,1173) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g177 || (_g177 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(690,1173) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g178 || (_g178 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(897,1173) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g179 || (_g179 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(966,1173) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g180 || (_g180 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035,1173) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g181 || (_g181 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1104,1173) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g182 || (_g182 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,1173) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g183 || (_g183 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1518,1173) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g184 || (_g184 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1587,1173) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g185 || (_g185 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1725,1173) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g186 || (_g186 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1932,1173) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g187 || (_g187 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,1242) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g188 || (_g188 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345,1242) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g189 || (_g189 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(414,1242) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g190 || (_g190 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,1242) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g191 || (_g191 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,1242) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g192 || (_g192 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(621,1242) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g193 || (_g193 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(759,1242) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g194 || (_g194 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828,1242) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g195 || (_g195 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(966,1242) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g196 || (_g196 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035,1242) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g197 || (_g197 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1104,1242) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g198 || (_g198 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1449,1242) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g199 || (_g199 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1518,1242) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g200 || (_g200 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1863,1242) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g201 || (_g201 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1932,1242) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g202 || (_g202 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(276,1311) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g203 || (_g203 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(621,1311) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g204 || (_g204 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(690,1311) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g205 || (_g205 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828,1311) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g206 || (_g206 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(966,1311) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g207 || (_g207 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,1311) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g208 || (_g208 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1311,1311) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g209 || (_g209 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1518,1311) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g210 || (_g210 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1656,1311) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g211 || (_g211 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1863,1311) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g212 || (_g212 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1932,1311) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g213 || (_g213 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,1380) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g214 || (_g214 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(276,1380) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g215 || (_g215 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(414,1380) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g216 || (_g216 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483,1380) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g217 || (_g217 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(759,1380) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g218 || (_g218 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035,1380) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g219 || (_g219 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1104,1380) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g220 || (_g220 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,1380) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g221 || (_g221 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1311,1380) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g222 || (_g222 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,1380) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g223 || (_g223 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1449,1380) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g224 || (_g224 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1518,1380) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g225 || (_g225 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1587,1380) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g226 || (_g226 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1656,1380) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g227 || (_g227 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1794,1380) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g228 || (_g228 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,1449) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g229 || (_g229 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(690,1449) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g230 || (_g230 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(759,1449) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g231 || (_g231 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828,1449) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g232 || (_g232 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(966,1449) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g233 || (_g233 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035,1449) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g234 || (_g234 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1242,1449) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g235 || (_g235 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1311,1449) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g236 || (_g236 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,1449) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g237 || (_g237 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1656,1449) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g238 || (_g238 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1794,1449) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g239 || (_g239 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1863,1449) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g240 || (_g240 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1932,1449) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g241 || (_g241 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(621,1518) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g242 || (_g242 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828,1518) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g243 || (_g243 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,1518) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g244 || (_g244 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,1518) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g245 || (_g245 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1518,1518) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g246 || (_g246 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1656,1518) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g247 || (_g247 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1863,1518) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g248 || (_g248 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,1587) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g249 || (_g249 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(621,1587) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g250 || (_g250 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(690,1587) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g251 || (_g251 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(759,1587) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g252 || (_g252 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(966,1587) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g253 || (_g253 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035,1587) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g254 || (_g254 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1104,1587) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g255 || (_g255 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1242,1587) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g256 || (_g256 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,1587) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g257 || (_g257 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1656,1587) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g258 || (_g258 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1725,1587) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g259 || (_g259 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1794,1587) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g260 || (_g260 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1932,1587) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g261 || (_g261 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(690,1656) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g262 || (_g262 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,1656) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g263 || (_g263 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,1656) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g264 || (_g264 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1449,1656) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g265 || (_g265 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1518,1656) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g266 || (_g266 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1587,1656) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g267 || (_g267 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1656,1656) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g268 || (_g268 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1863,1656) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g269 || (_g269 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,1725) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g270 || (_g270 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(621,1725) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g271 || (_g271 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(897,1725) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g272 || (_g272 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,1725) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g273 || (_g273 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1311,1725) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g274 || (_g274 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,1725) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g275 || (_g275 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1518,1725) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g276 || (_g276 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1587,1725) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g277 || (_g277 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1656,1725) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g278 || (_g278 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1725,1725) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g279 || (_g279 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1794,1725) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g280 || (_g280 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1932,1725) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g281 || (_g281 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(621,1794) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g282 || (_g282 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(690,1794) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g283 || (_g283 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(759,1794) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g284 || (_g284 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(897,1794) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g285 || (_g285 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(966,1794) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g286 || (_g286 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1242,1794) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g287 || (_g287 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1449,1794) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g288 || (_g288 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1587,1794) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g289 || (_g289 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1656,1794) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g290 || (_g290 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1725,1794) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g291 || (_g291 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1794,1794) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g292 || (_g292 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1932,1794) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g293 || (_g293 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828,1863) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g294 || (_g294 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1104,1863) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g295 || (_g295 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,1863) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g296 || (_g296 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,1863) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g297 || (_g297 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1587,1863) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g298 || (_g298 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1863,1863) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g299 || (_g299 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,1932) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g300 || (_g300 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(621,1932) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g301 || (_g301 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(759,1932) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g302 || (_g302 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828,1932) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g303 || (_g303 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1035,1932) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g304 || (_g304 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173,1932) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g305 || (_g305 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380,1932) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g306 || (_g306 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1587,1932) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g307 || (_g307 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1656,1932) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g308 || (_g308 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1863,1932) scale(0.69,0.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g309 || (_g309 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) scale(4.83, 4.83)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M65.859,15.008H34.141c-4.082,0-7.869,1.258-10.979,3.398c-2.419,1.665-4.428,3.864-5.848,6.421 C15.838,27.484,15,30.526,15,33.758v32.471c0,10.344,8.586,18.76,19.145,18.76L50,84.992l15.855-0.004 C76.414,84.988,85,76.572,85,66.229V33.758C85,23.419,76.414,15.008,65.859,15.008z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.859,0.008H34.141h0C18.683,0.008,5.587,10.221,1.4,24.18c-0.433,1.444-0.771,2.928-1.006,4.445 C0.135,30.299,0,32.013,0,33.758v32.471c0,18.619,15.32,33.76,34.141,33.76L50,99.992l15.859-0.004 c18.82,0,34.141-15.141,34.141-33.76V33.758C100,15.148,84.68,0.008,65.859,0.008z M85,66.229c0,10.344-8.586,18.76-19.145,18.76 L50,84.992l-15.855-0.004C23.586,84.988,15,76.572,15,66.229V33.758c0-3.231,0.838-6.273,2.313-8.931 c1.42-2.557,3.429-4.756,5.848-6.421c3.11-2.141,6.897-3.398,10.979-3.398h31.719C76.414,15.008,85,23.419,85,33.758V66.229z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1518,0) scale(4.83, 4.83)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M65.859,15.008H34.141c-4.082,0-7.869,1.258-10.979,3.398c-2.419,1.665-4.428,3.864-5.848,6.421 C15.838,27.484,15,30.526,15,33.758v32.471c0,10.344,8.586,18.76,19.145,18.76L50,84.992l15.855-0.004 C76.414,84.988,85,76.572,85,66.229V33.758C85,23.419,76.414,15.008,65.859,15.008z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.859,0.008H34.141h0C18.683,0.008,5.587,10.221,1.4,24.18c-0.433,1.444-0.771,2.928-1.006,4.445 C0.135,30.299,0,32.013,0,33.758v32.471c0,18.619,15.32,33.76,34.141,33.76L50,99.992l15.859-0.004 c18.82,0,34.141-15.141,34.141-33.76V33.758C100,15.148,84.68,0.008,65.859,0.008z M85,66.229c0,10.344-8.586,18.76-19.145,18.76 L50,84.992l-15.855-0.004C23.586,84.988,15,76.572,15,66.229V33.758c0-3.231,0.838-6.273,2.313-8.931 c1.42-2.557,3.429-4.756,5.848-6.421c3.11-2.141,6.897-3.398,10.979-3.398h31.719C76.414,15.008,85,23.419,85,33.758V66.229z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,1518) scale(4.83, 4.83)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M65.859,15.008H34.141c-4.082,0-7.869,1.258-10.979,3.398c-2.419,1.665-4.428,3.864-5.848,6.421 C15.838,27.484,15,30.526,15,33.758v32.471c0,10.344,8.586,18.76,19.145,18.76L50,84.992l15.855-0.004 C76.414,84.988,85,76.572,85,66.229V33.758C85,23.419,76.414,15.008,65.859,15.008z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.859,0.008H34.141h0C18.683,0.008,5.587,10.221,1.4,24.18c-0.433,1.444-0.771,2.928-1.006,4.445 C0.135,30.299,0,32.013,0,33.758v32.471c0,18.619,15.32,33.76,34.141,33.76L50,99.992l15.859-0.004 c18.82,0,34.141-15.141,34.141-33.76V33.758C100,15.148,84.68,0.008,65.859,0.008z M85,66.229c0,10.344-8.586,18.76-19.145,18.76 L50,84.992l-15.855-0.004C23.586,84.988,15,76.572,15,66.229V33.758c0-3.231,0.838-6.273,2.313-8.931 c1.42-2.557,3.429-4.756,5.848-6.421c3.11-2.141,6.897-3.398,10.979-3.398h31.719C76.414,15.008,85,23.419,85,33.758V66.229z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138,138) scale(2.07, 2.07)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g310 || (_g310 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.351,100c-15.09,0-27.365-12.032-27.365-26.808V26.794c0-4.616,1.2-8.96,3.301-12.761 c2.029-3.658,4.901-6.802,8.36-9.174C16.09,1.801,21.506,0,27.336,0h45.327c15.076,0,27.351,12.018,27.351,26.793v46.398 c0,14.775-12.274,26.808-27.351,26.808H50H27.351z"
  })), /*#__PURE__*/React.createElement("g", null)))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1656,138) scale(2.07, 2.07)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g311 || (_g311 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.351,100c-15.09,0-27.365-12.032-27.365-26.808V26.794c0-4.616,1.2-8.96,3.301-12.761 c2.029-3.658,4.901-6.802,8.36-9.174C16.09,1.801,21.506,0,27.336,0h45.327c15.076,0,27.351,12.018,27.351,26.793v46.398 c0,14.775-12.274,26.808-27.351,26.808H50H27.351z"
  })), /*#__PURE__*/React.createElement("g", null)))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138,1656) scale(2.07, 2.07)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _g312 || (_g312 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.351,100c-15.09,0-27.365-12.032-27.365-26.808V26.794c0-4.616,1.2-8.96,3.301-12.761 c2.029-3.658,4.901-6.802,8.36-9.174C16.09,1.801,21.506,0,27.336,0h45.327c15.076,0,27.351,12.018,27.351,26.793v46.398 c0,14.775-12.274,26.808-27.351,26.808H50H27.351z"
  })), /*#__PURE__*/React.createElement("g", null)))))))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2001,
    height: 2001,
    fill: "url(#grad)",
    mask: "url(#gmask)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeltegramQr);
export default __webpack_public_path__ + "static/media/teltegram_QR.f4e033d14d8ac0853f58065bdafe5877.svg";
export { ForwardRef as ReactComponent };